module.exports = __webpack_public_path__ + "img/multihub.290c9529.jpg";